module.exports = __webpack_public_path__ + "eddc0bfa.svg";